import React, { useEffect, useRef, useState } from 'react';
import AutoSelectInput from "../common/AutoSelectInput";

const SchedulesPopup = ({ x, y, onClose, onConfirm, schedules = [] }) => {
    const popupRef = useRef(null);
    const firstInputRef = useRef(null);

    const [currentSchedules, setCurrentSchedules] = useState([...schedules, '']);

    useEffect(() => {
        // Focar no primeiro input ao abrir
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);

    const handleScheduleChange = (index, value) => {
        // Mantém o valor original para verificação
        const originalValue = value;

        // Remove tudo que não for número
        let newvalue = value.replace(/[^0-9]/g, '');

        // Aplica a formatação para hh:mm
        if (newvalue.length > 4) {
            newvalue = newvalue.slice(0, 4);
        }
        if (newvalue.length >= 3) {
            newvalue = newvalue.slice(0, 2) + ':' + newvalue.slice(2);
        }

        // Atualiza o array de schedules
        let newSchedules = [...currentSchedules];
        newSchedules[index] = newvalue;

        // 👉 Adiciona um novo campo se está editando o último e há valor
        if (index === currentSchedules.length - 1 && newvalue) {
            newSchedules = [...newSchedules, ''];
            setCurrentSchedules(newSchedules);
            return;
        }

        // 👉 Só remove se o usuário realmente apagou (campo vazio no original, não por regex)
        if (originalValue === '' && currentSchedules.length > 1) {
            newSchedules = currentSchedules.filter((_, idx) => idx !== index);
            setCurrentSchedules(newSchedules);
            return;
        }

        setCurrentSchedules(newSchedules);
    };


    return (
        <div
            ref={popupRef}
            style={{
                position: 'absolute',
                top: y,
                left: x,
                backgroundColor: 'white',
                borderRadius: '8px',
                border: '1px solid #ccc',
                padding: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                zIndex: 1000,
                minWidth: '200px'
            }}
        >
            <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                Horários
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {currentSchedules.map((schedule, index) => (
                    <AutoSelectInput
                        key={index}
                        type="text"
                        value={schedule}
                        onChange={(e) => handleScheduleChange(index, e.target.value)}
                        placeholder="HH:mm"
                        ref={index === 0 ? firstInputRef : null}  // Aplica o ref só no primeiro
                    />
                ))}
            </div>

            <div style={{ marginTop: '12px', textAlign: 'right' }}>
                <button onClick={() => onConfirm(currentSchedules.filter((_, idx) => idx < currentSchedules.length - 1))}>Ok</button>
            </div>
        </div>
    );
};

export default SchedulesPopup;
